(() => {
  'use strict';
  const finishLabel = value => ({Gold:'18K Gold-Plated',Silver:'Silver Stainless Steel','Rose Gold':'18K Rose-Gold-Plated'})[value] || value;
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100);
  function init(extras) {
    if (extras.dataset.ready === 'true') return;
    const root = extras.closest('[data-mpn-design-preview]');
    if (!root) return;
    extras.dataset.ready = 'true';
    const q = selector => root.querySelector(selector);
    const checks = [...extras.querySelectorAll('[data-mpn-extra]')];
    const review = q('[data-mpn-design-review]');
    const dialog = extras.querySelector('[data-mpn-review-dialog]');
    const secondPhoto = q('[data-extra-photo]');
    const secondImage = q('[data-extra-photo-preview]');
    const secondError = q('[data-extra-error]');
    let secondUrl = null, version = 0;
    const checked = key => checks.find(input => input.dataset.mpnExtra === key)?.checked;
    const primaryFinish = () => q('[data-mpn-preview-finish]').value;
    const finishFor = key => {const v = q(`[data-extra-finish="${key}"]`).value; return v === 'match' ? primaryFinish() : v;};
    const basePrice = () => q('[data-mpn-preview-engraving]').value === 'back' ? 5990 : 4995;
    const total = () => basePrice() + checks.filter(input => input.checked).reduce((sum,input) => sum + Number(input.value), 0);
    const otherPet = () => checked('necklace') && q('[data-extra-pet]').value === 'different';
    function ready() {
      const primaryPhoto = q('[data-mpn-preview-image]');
      const hasPrimary = q('[data-mpn-preview-name]').value.trim() && primaryPhoto && !primaryPhoto.hidden && primaryPhoto.querySelector('img').getAttribute('src');
      const backInput = q('[data-mpn-preview-back] input');
      const hasBack = q('[data-mpn-preview-engraving]').value !== 'back' || backInput.value.trim();
      return Boolean(hasPrimary && hasBack && (!otherPet() || (q('[data-extra-name]').value.trim() && secondUrl)));
    }
    function sync() {
      checks.forEach(input => {
        const key = input.dataset.mpnExtra;
        q(`[data-extra-card="${key}"]`).dataset.selected = String(input.checked);
        q(`[data-extra-settings="${key}"]`).hidden = !input.checked;
      });
      q('[data-extra-another-pet]').hidden = !otherPet();
      const keychainImage = q('[data-extra-keychain-image]');
      if (keychainImage) {
        const finish = finishFor('keychain');
        const source = {'Gold': keychainImage.dataset.goldSrc, 'Silver': keychainImage.dataset.silverSrc, 'Rose Gold': keychainImage.dataset.roseGoldSrc}[finish];
        // Never present a gold concept as a different finish if its artwork is missing.
        keychainImage.hidden = !source;
        if (source) keychainImage.src = source;
        else keychainImage.removeAttribute('src');
        keychainImage.alt = `Illustration of a ${finishLabel(finish)} pet portrait keychain; example engraving, not your personalized result`;
      }
      document.querySelectorAll('[data-mpn-add-extra]').forEach(button => {
        button.disabled = false;
        button.firstChild.textContent = checked(button.dataset.mpnAddExtra) ? 'Edit this extra in my design ' : button.dataset.offerLabel + ' ';
      });
      const price = money(total());
      root.querySelectorAll('[data-mpn-upsell-total]').forEach(node => {node.textContent = price;});
      const count = checks.filter(input => input.checked).length;
      q('[data-extra-status]').textContent = count ? `${count} optional ${count === 1 ? 'extra' : 'extras'} selected · one-time selection total ${price}.` : 'No extras selected.';
      if (review) {review.disabled = !ready(); review.textContent = ready() ? `Review my design — ${price}` : 'Add your photo and details to review';}
    }
    function clearSecond() {
      version++; secondPhoto.value = ''; secondImage.hidden = true; secondImage.removeAttribute('src');
      q('[data-extra-photo-remove]').hidden = true;
      if (secondUrl) URL.revokeObjectURL(secondUrl);
      secondUrl = null; sync();
    }
    secondPhoto.addEventListener('change', async () => {
      const ticket = ++version; secondImage.hidden = true; secondError.textContent = '';
      if (secondUrl) URL.revokeObjectURL(secondUrl); secondUrl = null;
      const file = secondPhoto.files[0]; sync();
      if (!file) return;
      if (!['image/jpeg','image/png'].includes(file.type) || !/\.(jpe?g|png)$/i.test(file.name) || !file.size || file.size > 10*1024*1024) {clearSecond(); secondError.textContent = 'Choose a JPG or PNG photo, up to 10 MB.';return;}
      const candidate = URL.createObjectURL(file), probe = new Image();probe.src = candidate;
      try {
        await probe.decode();
        if (ticket !== version || !root.isConnected) {URL.revokeObjectURL(candidate);return;}
        secondUrl = candidate;secondImage.src = candidate;secondImage.hidden = false;q('[data-extra-photo-remove]').hidden = false;sync();
      } catch {URL.revokeObjectURL(candidate);if(ticket === version){clearSecond();secondError.textContent = 'This photo could not be opened. Choose another.';}}
    });
    q('[data-extra-photo-remove]').addEventListener('click', () => {clearSecond();secondError.textContent = '';});
    const observer = new MutationObserver(sync);
    observer.observe(q('[data-mpn-preview-image]'),{attributes:true,attributeFilter:['hidden'],childList:true,subtree:true});
    root.addEventListener('change',sync);root.addEventListener('input',sync);
    review?.addEventListener('click', () => {
      if (!ready()) {sync();return;}
      const list = q('[data-mpn-review-lines]');list.replaceChildren();
      const add = (title,detail,price) => {const li=document.createElement('li'),text=document.createElement('span'),small=document.createElement('small'),cost=document.createElement('strong');text.textContent=title;small.textContent=detail;text.append(small);cost.textContent=money(price);li.append(text,cost);list.append(li);};
      const pet = q('[data-mpn-preview-name]').value.trim();
      const back = q('[data-mpn-preview-engraving]').value === 'back';
      add(`Your necklace · ${pet}`,`${finishLabel(primaryFinish())} · portrait + name${back ? ` · Back: ${q('[data-mpn-preview-back] input').value.trim()}` : ''}`,basePrice());
      if (checked('keychain')) add(`Matching keychain · ${pet}`,`${finishLabel(finishFor('keychain'))} · same photo and name · front only`,2995);
      if (checked('necklace')) add(`Second necklace · ${otherPet() ? q('[data-extra-name]').value.trim() : pet}`,`${finishLabel(finishFor('necklace'))} · ${otherPet() ? 'different pet photo' : 'same pet photo'} · front only`,3495);
      q('[data-mpn-review-total]').textContent=money(total());q('[data-mpn-review-photo]').src=q('[data-mpn-preview-image] img').src;
      if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
      dialog.querySelector('[data-mpn-review-close]').focus();
    });
    dialog.querySelectorAll('[data-mpn-review-close]').forEach(button=>button.addEventListener('click',()=>{if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');review?.focus();}));
    dialog.addEventListener('close',()=>review?.focus());
    const unload = event => {if(!event.target.contains(root))return;observer.disconnect();clearSecond();document.removeEventListener('shopify:section:unload',unload);};
    document.addEventListener('shopify:section:unload',unload);sync();
  }
  // Gift cards are a deliberate shortcut into the same optional choices, never a cart action.
  if (!window.__mpnGiftOffersBound) {
    window.__mpnGiftOffersBound = true;
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-mpn-add-extra]');
      if (!button || button.disabled) return;
      const extras = document.querySelector('[data-mpn-upsell-preview][data-ready="true"]');
      const root = extras?.closest('[data-mpn-design-preview]');
      const checkbox = extras?.querySelector(`[data-mpn-extra="${button.dataset.mpnAddExtra}"]`);
      if (!root || !checkbox) return;
      checkbox.checked = true; checkbox.dispatchEvent(new Event('change', {bubbles:true}));
      const details = root.querySelector('[data-mpn-personalizer]');
      if (details) details.open = true;
      requestAnimationFrame(() => {
        checkbox.closest('[data-extra-card]')?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        checkbox.focus({preventScroll:true});
      });
    });
  }
  const all = scope => scope.querySelectorAll('[data-mpn-upsell-preview]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all(document),{once:true});else all(document);
  document.addEventListener('shopify:section:load',event=>{all(event.target);if(document.querySelector('[data-mpn-upsell-preview][data-ready="true"]'))document.querySelectorAll('[data-mpn-add-extra]').forEach(button=>{button.disabled=false;});});
})();
